import React from 'react';
import { Link } from 'react-router-dom';
import vk from './vk40.png';
import tg from './tg.svg';

function Footer({ variant }) {
  const isAuth = variant === 'auth';
  const isAuthenticated = Boolean(localStorage.getItem('token'));
  const resolveGuestHref = (href) => (isAuthenticated || href === '/' ? href : '/log_in');

  const navLinks = [
    { href: '/', label: 'Главная' },
    { href: '/chats', label: 'Чаты' },
    { href: '/feed', label: 'Лента' },
    { href: '/search', label: 'Поиск' },
    { href: '/sympathies', label: 'Симпатии' },
  ];

  const okIcon = (
    <svg
      className="footer-ok-icon"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M0 19.1981C0 10.151 0 5.63144 2.81572 2.81572C5.62744 0 10.151 0 19.1941 0H20.7979C29.845 0 34.3646 0 37.1803 2.81572C39.996 5.63144 39.996 10.151 39.996 19.1981V20.8019C39.996 29.849 39.996 34.3686 37.1803 37.1843C34.3646 40 29.845 40 20.7979 40H19.1941C10.147 40 5.62744 40 2.81172 37.1843C0 34.3686 0 29.845 0 20.7979V19.1981Z"
        fill="var(--footer-ok-bg)"
      />
      <path
        d="M19.998 19.8904C21.9578 19.8904 23.7176 19.1065 25.0015 17.8267C26.2813 16.5468 27.0653 14.763 27.0653 12.8232C27.0653 10.8833 26.2813 9.10352 25.0015 7.81965C23.7216 6.53978 21.9578 5.75586 19.998 5.75586C18.0382 5.75586 16.2783 6.53978 14.9945 7.81965C13.7146 9.09952 12.9307 10.8633 12.9307 12.8232C12.9307 14.783 13.7146 16.5428 14.9945 17.8267C16.2743 19.0905 18.0382 19.8904 19.998 19.8904ZM17.7342 10.5434C18.3221 9.95544 19.122 9.59947 19.994 9.59947C20.8659 9.59947 21.6858 9.95544 22.2537 10.5434C22.8417 11.1313 23.1976 11.9312 23.1976 12.8032C23.1976 13.6751 22.8417 14.495 22.2537 15.0629C21.6658 15.6509 20.8659 16.0068 19.994 16.0068C19.122 16.0068 18.3021 15.6509 17.7342 15.0629C17.1462 14.475 16.7903 13.6751 16.7903 12.8032C16.7903 11.9312 17.1462 11.1313 17.7342 10.5434Z"
        fill="var(--footer-ok-mark)"
      />
      <path
        d="M29.505 22.7418L27.4212 19.9101C27.2972 19.7501 27.0852 19.7301 26.9213 19.8581C24.9615 21.5339 22.5577 22.6018 19.978 22.6018C17.3942 22.6018 14.9905 21.5139 13.0347 19.8581C12.8907 19.7341 12.6587 19.7501 12.5347 19.9101L10.4669 22.7418C10.3589 22.8858 10.3949 23.0778 10.5189 23.1858C12.2627 24.6096 14.2945 25.5535 16.4143 26.0535L12.0348 33.7647C11.9268 33.9807 12.0867 34.2447 12.3387 34.2447H16.6303C16.7543 34.2447 16.8783 34.1727 16.9343 34.0487L19.998 27.2094L23.0616 34.0487C23.1136 34.1727 23.2416 34.2447 23.3656 34.2447H27.6572C27.9052 34.2447 28.0651 33.9767 27.9412 33.7647L23.5576 26.0535C25.6774 25.5535 27.6892 24.6096 29.433 23.1858C29.577 23.0778 29.593 22.8818 29.505 22.7418Z"
        fill="var(--footer-ok-mark)"
      />
    </svg>
  );

  const socialLinks = (
    <div className="footer__socials">
      <a href="#" className="icon-link" aria-label="VK">
        <img src={vk} alt="VK" />
      </a>
      <a href="#" className="icon-link" aria-label="Telegram">
        <img src={tg} alt="TG" />
      </a>
      <a href="#" className="icon-link" aria-label="Одноклассники">
        {okIcon}
      </a>
    </div>
  );

  const phoneBlock = (
    <>
      <p className="footer__phone-title">
        8 (800) 555-35-35 <span className="footer__phone-title-lite">или</span> 555
      </p>
      <p className="footer__phone-note">Бесплатно для звонков по России</p>
    </>
  );

  const logoBlock = (
    <div className="footer__logo">
      <Link to="/" className="footer__logo-link" aria-label="Перейти на главную страницу">
        <div className="brand-logo">
          <span className="brand-logo__accent">T</span>
          <span className="brand-logo__text">-Interest</span>
        </div>
      </Link>
    </div>
  );

  const navBlock = (extraClass) => (
    <nav className={`footer__nav${extraClass ? ` ${extraClass}` : ''}`}>
      {navLinks.map((link) => (
        <Link key={link.href} to={resolveGuestHref(link.href)} className="site-link">
          {link.label}
        </Link>
      ))}
    </nav>
  );

  const textBlock = (
    <div className="footer__text">
      <p className="footer__cookie">
        АНО «T-Interest» использует файлы «cookie», с целью персонализации сервисов и повышения
        удобства пользования веб-сайтом. «Cookie»
        <br />
        представляют собой небольшие файлы, содержащие информацию о предыдущих посещениях
        веб-сайта.
      </p>
      <div className="footer__contacts-row">
        <p className="footer__contacts">
          По всем вопросам обращайся на{' '}
          <a href="mailto:tinterest@tbank.ru" className="footer__mail">
            tinterest@tbank.ru
          </a>
        </p>
      </div>
    </div>
  );

  const bottomBlock = (
    <div className="footer__bottom">
      <div className="footer__mobile-row">
        <div className="footer__phone-mobile">
          {phoneBlock}
        </div>
        {socialLinks}
      </div>

      <div className="section-divider footer__mobile-divider" />

      <p className="footer__copyright">© 2026, АНО «T-Interest». Все права защищены</p>
      <div className="footer__socials footer__socials--desktop">{socialLinks.props.children}</div>
    </div>
  );

  return (
    <footer className={`footer${isAuth ? ' footer--auth' : ''}`}>
      <div className="footer__inner layout-12">
        {isAuth ? (
          <div className="footer__auth-top">
            <div className="footer__auth-left">
              {logoBlock}
              {navBlock('footer__nav--auth')}
            </div>
            <div className="footer__phone-desktop footer__phone-desktop--auth">{phoneBlock}</div>
          </div>
        ) : (
          <>
            {logoBlock}
            <div className="footer__head">
              {navBlock()}
              <div className="footer__phone-desktop">{phoneBlock}</div>
            </div>
          </>
        )}

        {textBlock}

        <div className="section-divider" />

        {bottomBlock}
      </div>
    </footer>
  );
}

export default Footer;
